import React from 'react';
import { DOCUMENTS_BY_PROCESS_COLUMNS, USERS_COLUMNS } from '../../common/initialValues/initialValues';
import { useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import arrowDown from '../../assets/icons/arrow-down-orange-icon.svg';
import emptyTableIcon from '../../assets/icons/empty-state-illustration.svg';

interface Props {
  tableData: { processTypeId: string; amount: string }[];
}
export const DocumentsByProcessIdTable = ({ tableData }: Props) => {
  const columns = React.useMemo(() => DOCUMENTS_BY_PROCESS_COLUMNS, []);
  const data = React.useMemo(() => tableData, [tableData]);

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, state } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 50 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className='relative font-h5-regular margin-bottom-3'>
      {/* <div className='filters'>
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div> */}
      {page.length ? (
        <>
          <table className='font-h5-regular simply-table full-width' {...getTableProps}>
            <thead className='simply-table__head'>
              {headerGroups.map((headerGroup, index) => (
                <tr className='simply-table__head__row' {...headerGroup.getFooterGroupProps()} key={index}>
                  {headerGroup.headers.map((column, index) => (
                    <th
                      className={`${column.isSorted && 'primary-200'} simply-table__head__row__th font-h5-regular`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      key={index}
                    >
                      <span>{column.render('Header')}</span>

                      {column.isSorted ? <img src={arrowDown} alt='' className={`${column.isSortedDesc && 'rotate-180'}`} /> : ''}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className='simply-table__body' {...getTableBodyProps}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <tr className='simply-table__body__row' {...row.getRowProps()} key={index}>
                    {row.cells.map((cell, i) => {
                      return (
                        <td className='simply-table__body__column' {...cell.getCellProps()} key={i}>
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <>
          <div className='text-center padding-top-4'>
            <picture className='height-60'>
              <img className='height-60' src={emptyTableIcon} alt='' />
            </picture>
            <h3 className='font-h3-regular margin-top-1'>Nothing here yet</h3>
          </div>
        </>
      )}
    </div>
  );
};
